import React from "react";
import Card from "./TeamCard";
import Detail from "../Teams/TeamDetail";
import '../../../styles/team.css';

function createCard(contact) {
  return (
    <Card
      key={contact.id}
      name={contact.name}
      img={contact.imageURL}
      designation={contact.designation}
    />
  );
}

function teamCards() {
  return (
    <div>
      <h1 className="team-heading">
        <span>Our Team!</span>
        </h1>
      <dl className="team-card">{Detail.map(createCard)}</dl>
    </div>
  );
}

export default teamCards;
